<template>
    <div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;">
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb> -->
        <div style="border-bottom: 1px solid #eeeeee;height:22px;padding:20px;">
            <div style="text-align:left;height:20px;line-height:20px;">
                <div style="float:left;border-left: 4px solid #42b6ff;height:20px;"></div>
                <div style="float:left;margin-left:8px;"><span>待处理的评估任务</span></div>
                <div style="float:left;margin-left:10px;"><el-badge :value="ChengShu_todo" /></div>
            </div>
        </div>
        <div style="margin-top:17px;padding:0 20px;">
            <el-alert
                :title="tips"
                type="warning"
                show-icon
                style="border:1px solid #ffd18c;">
            </el-alert>
        </div>
        <div style="margin-top:17px;padding:0 20px;">
            <!-- <router-view></router-view> -->
            <!-- 这里两个子组件需要使用v-show进行过滤，主要是为了让子组件随父组件一起加载，用v-if只有在点击显示的时候才会加载，这样就获取不到子组件的未完成数了！ -->
            <cheng-shu v-show="this.selected_assess=='管理基本功评估'" ref="chengshu_ref" @sendToDoNum="getToDoNum"></cheng-shu>
            <!-- <jian-kang v-show="this.selected_assess=='组织健康度测评'" style="position:relative;top:-10px;" ref="jiankang_ref"></jian-kang> -->
        </div>
        <!-- <div v-if="no_task_flag" class="no_task">
            <span>暂无待评估的任务，可<el-button type="text" @click="view_finished_info" class="view_details">单击此处</el-button>查看已完成的评估。</span>
        </div> -->
    </div>
</template>

<script>
import chengShu from "./ChengShu_todo.vue";
// import jianKang from "./JianKang_todo.vue";
import getdata from "@/api/getData.js";

export default {
    beforeCreate() {
        getdata.getList("checklogin")
              .then((resp) => {
                // 企业用户无权登录
                if(resp.data.usertype=='company'){
                    this.$router.push({
                    path: '/company',
                });
                }
              })
              .catch(() => {
                if(localStorage.getItem("token") != null){
                    this.$message({
                        message: '会话超时，请重新登录！',
                        type: 'warning',
                    })
                }
                this.$router.push({
                    path: '/login',
                });
              })
    },
    // 监控每个测评的未完成数，如果都完成了，则直接显示暂无待评估的任务
    watch: {
        ChengShu_todo: {
            handler(val) {
                if(val==null && this.JianKang_todo==null){
                    this.exist_task_flag = false;
                    this.no_task_flag = true;
                }else{
                    this.exist_task_flag = true;
                    this.no_task_flag = false;
                }
            },
            immediate: true,
        },
        // JianKang_todo: {
        //     handler(val) {
        //         if(val==null && this.ChengShu_todo==null){
        //             this.exist_task_flag = false;
        //             this.no_task_flag = true;
        //         }else{
        //             this.exist_task_flag = true;
        //             this.no_task_flag = false;
        //         }
        //     },
        //     immediate: true,
        // },
    },
    components: {
        chengShu,
        // jianKang,
    },
    data() {
        return {
            selected_assess: '管理基本功评估',
            ChengShu_todo: null,
            JianKang_todo: null,
            exist_task_flag: false,
            no_task_flag: false,
            tips: '亲爱的同学，您所提供的评价以及个人信息都将做严格的保密处理，脱敏匿名统计数据将用于帮助被评估人发现自己的优势和需要提升的方向，请放心客观作答。',
        }
    },
    methods: {
        display_ChengShu_todo() {
            // this.$router.push({
            //     path: '/chengshu_todo',
            // }) 
            this.selected_assess = '管理基本功评估';
        },
        display_JianKang_todo() {
            // this.$router.push({
            //     path: '/jiankang_todo',
            // })
            this.selected_assess = '组织健康度测评';
        },
        getToDoNum(num) {
            if(num<0){
                this.ChengShu_todo = null;
            }else{
                this.ChengShu_todo = num;
            }
        },
        view_finished_info() {
            this.exist_task_flag = true;
            this.no_task_flag = false;
        },
    }
    // components: {
    //     quesmana,
    //     usermana,
    //     condmana,
    //     relationmana,
    // }
}
</script>

<style scoped>
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
}
.badge_area {
    width: 100%;
    margin-top: 20px;
}
.el-badge {
    float: left;
    margin-right: 35px;
}
.el-badge /deep/ .el-button {
    font-size: 18px;
    font-weight: bold;
}
::v-deep .el-badge__content {
    font-size: 16px;
}
::v-deep .el-alert__content {
    text-align: left;
}
.my_todo {
    text-align: left;
    border: 1px solid #E4E7ED;
    height: 100px;
    padding: 15px;
    background: #f5f7fa;
}
.my_todo span{
    font-size: 20px;
    font-weight: bold;
    color: #606266;
}
::v-deep .el-alert__title {
    font-size: 14px;
}
.no_task {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
}
.view_details {
  margin: 0 auto;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
  font-size: 16px;
}
::v-deep .el-badge__content {
  font-size: 12px;
  padding: 0 8px;
}
::v-deep .el-alert--warning.is-light {
  background-color: #fff9ef;
  color: #ffaa2c;
}
</style>